import { render, staticRenderFns } from "./TenantRental.vue?vue&type=template&id=99b1c23e&scoped=true&"
import script from "./TenantRental.vue?vue&type=script&lang=js&"
export * from "./TenantRental.vue?vue&type=script&lang=js&"
import style0 from "./TenantRental.vue?vue&type=style&index=0&id=99b1c23e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b1c23e",
  null
  
)

export default component.exports